import React from 'react';
import Logo from '../Logo';

const ComparisonTable = () => {
    return (
        <div className="self-stretch px-8 py-16 bg-neutral-800 flex flex-col justify-center items-center gap-12">
            <div className="max-w-5xl mx-auto w-full">
                <div className="text-center mb-12">
                    <h2 className="!text-white text-3xl lg:text-4xl font-bold font-['Montserrat'] mb-4">
                        Beyond Traditional AI Bots
                    </h2>
                    <p className="!text-stone-300 text-lg font-medium font-['Inter']">
                        See what makes our assistant indistinguishable from a human teammate.
                    </p>
                </div>

                <div className="overflow-x-auto">
                    <table className="w-full bg-neutral-900 rounded-lg overflow-hidden">
                        <thead>
                            <tr className="bg-neutral-700">
                                <th className="text-left p-4 !text-white text-sm font-bold font-['Montserrat']">Capabilities</th>
                                <th className="text-center p-4 !text-stone-300 text-sm font-bold font-['Montserrat']">Legacy AI Bots</th>
                                <th className="text-center p-4 !text-blue-400 text-sm font-bold font-['Montserrat']"><center><Logo  height="26" /></center></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="border-t border-neutral-700 bg-neutral-800/50">
                                <td className="p-4 !text-stone-300 text-sm font-medium">Conversational Nuance</td>
                                <td className="p-4 text-center">
                                    <span className="text-stone-400 text-sm">Robotic</span>
                                </td>
                                <td className="p-4 text-center">
                                    <span className="text-blue-400 text-sm font-bold">Human-Level</span>
                                </td>
                            </tr>

                            <tr className="border-t border-neutral-700">
                                <td className="p-4 !text-stone-300 text-sm font-medium">Routes Calls</td>
                                <td className="p-4 text-center">
                                    <i className="fa fa-check text-green-500 text-lg"></i>
                                </td>
                                
                                <td className="p-4 text-center">
                                    <div className="flex flex-col items-center gap-1">
                                        <i className="fa fa-check text-green-500 text-lg"></i>
                                        <span className="text-blue-400 text-xs font-bold">Live Call Takeover, Department Transfer, Escalations</span>
                                    </div>
                                </td>
                            </tr>                            
                            <tr className="border-t border-neutral-700">
                                <td className="p-4 !text-stone-300 text-sm font-medium">Takes Messages</td>
                                <td className="p-4 text-center">
                                    <i className="fa fa-check text-green-500 text-lg"></i>
                                </td>
                                <td className="p-4 text-center">
                                    <div className="flex flex-col items-center gap-1">
                                        <i className="fa fa-check text-green-500 text-lg"></i>
                                        <span className="text-blue-400 text-xs font-bold">Live Call Transcripts, Email Transcripts</span>
                                    </div>
                                </td>
                            </tr>
                            <tr className="border-t border-neutral-700">
                                <td className="p-4 !text-stone-300 text-sm font-medium">Complete Schedule Ownership</td>

                                <td className="p-4 text-center">
                                    <div className="flex flex-col items-center gap-1">
                                        <i className="fa fa-times text-red-500 text-lg"></i>
                                        <span className="text-stone-400 text-sm">Human In The Loop</span>
                                    </div>
                                </td>                                
                                <td className="p-4 text-center">
                                    <div className="flex flex-col items-center gap-1">
                                        <i className="fa fa-check text-green-500 text-lg"></i>
                                        <span className="text-blue-400 text-xs font-bold">Create, Modify, Cancel through all channels</span>
                                    </div>
                                </td>
                            </tr>    
                            <tr className="border-t border-neutral-700 bg-neutral-800/50">
                                <td className="p-4 !text-stone-300 text-sm font-medium">Real-time Cross Channel Customer Interaction</td>
                                <td className="p-4 text-center">
                                    <div className="flex flex-col items-center gap-1">
                                        <i className="fa fa-times text-red-500 text-lg"></i>
                                        <span className="text-stone-400 text-sm">Voice or SMS or Email</span>
                                    </div>
                                </td>                                
                                <td className="p-4 text-center">
                                    <div className="flex flex-col items-center gap-1">
                                        <i className="fa fa-check text-green-500 text-lg"></i>
                                        <span className="text-blue-400 text-xs font-bold">Voice + SMS + Email with Cross Channel Memory</span>
                                    </div>
                                </td>                                
                            </tr>                            

                            <tr className="border-t border-neutral-700">
                                <td className="p-4 !text-stone-300 text-sm font-medium">Real-Time Staff Coordination</td>
                                <td className="p-4 text-center">
                                    <i className="fa fa-times text-red-500 text-lg"></i>
                                </td>
                                <td className="p-4 text-center">
                                    <div className="flex flex-col items-center gap-1">
                                        <i className="fa fa-check text-green-500 text-lg"></i>
                                        <span className="text-blue-400 text-xs font-bold">Real-Time Communication</span>
                                    </div>
                                </td>
                            </tr>
                            <tr className="border-t border-neutral-700 bg-neutral-800/50">
                                <td className="p-4 !text-stone-300 text-sm font-medium">Real-Time Payment Collection</td>

                                <td className="p-4 text-center">
                                    <div className="flex flex-col items-center gap-1">
                                        <i className="fa fa-times text-red-500 text-lg"></i>
                                        <span className="text-stone-400 text-sm">Sends a payment link</span>
                                    </div>
                                </td>                                
                                <td className="p-4 text-center">
                                    <div className="flex flex-col items-center gap-1">
                                        <i className="fa fa-check text-green-500 text-lg"></i>
                                        <span className="text-blue-400 text-xs font-bold">In-Call Payment Validation</span>
                                    </div>
                                </td>                                
                            </tr>                            
                            <tr className="border-t border-neutral-700 bg-neutral-800/50">
                                <td className="p-4 !text-stone-300 text-sm font-medium">Real-Time Backend Application Integration</td>
                                <td className="p-4 text-center">
                                    <i className="fa fa-check text-green-500 text-lg"></i>
                                </td>
                                <td className="p-4 text-center">
                                    <div className="flex flex-col items-center gap-1">
                                        <i className="fa fa-check text-green-500 text-lg"></i>
                                        <span className="text-blue-400 text-xs font-bold">Real-Time Synchronization</span>
                                    </div>
                                </td>
                            </tr>
                            <tr className="border-t border-neutral-700 bg-neutral-800/50">
                                <td className="p-4 !text-stone-300 text-sm font-medium">Low Latency Enterprise Scale</td>
                                <td className="p-4 text-center">
                                    <div className="flex flex-col items-center gap-1">
                                        <i className="fa fa-times text-red-500 text-lg"></i>
                                        <span className="text-stone-400 text-sm">OpenAI + MCP + Voice Wrapper</span>
                                    </div>
                                </td>                                                               
                                <td className="p-4 text-center">
                                    <div className="flex flex-col items-center gap-1">
                                        <i className="fa fa-check text-green-500 text-lg"></i>
                                        <span className="text-blue-400 text-xs font-bold">Proprietary Low Latency Enterprise Architecture (AWS)</span>
                                    </div>
                                </td>                                
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default ComparisonTable;
